import { useEffect, useState } from "react";
import { motion, useMotionValue, useSpring } from "framer-motion";

const Cursor = () => {
    const [enabled, setEnabled] = useState(false);
    const x = useMotionValue(-100);
    const y = useMotionValue(-100);
    const ringX = useSpring(x, { stiffness: 250, damping: 24, mass: 0.6 });
    const ringY = useSpring(y, { stiffness: 250, damping: 24, mass: 0.6 });

    useEffect(() => {
        const fine = window.matchMedia("(pointer: fine)").matches;
        const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
        if (!fine || reduced) return;
        setEnabled(true);
        document.body.classList.add("luxury-cursor-on");
        const move = (e) => {
            x.set(e.clientX);
            y.set(e.clientY);
        };
        const over = (e) => {
            const interactive = e.target.closest("a, button, input, select, textarea, [role='button'], [data-cursor]");
            document.getElementById("cursor-ring")?.classList.toggle("is-hover", !!interactive);
        };
        window.addEventListener("mousemove", move);
        window.addEventListener("mouseover", over);
        return () => {
            window.removeEventListener("mousemove", move);
            window.removeEventListener("mouseover", over);
            document.body.classList.remove("luxury-cursor-on");
        };
    }, [x, y]);

    if (!enabled) return null;
    return (
        <>
            <motion.div id="cursor-dot" style={{ x, y, translateX: "-50%", translateY: "-50%" }} />
            <motion.div id="cursor-ring" style={{ x: ringX, y: ringY, translateX: "-50%", translateY: "-50%" }} />
        </>
    );
};

export default Cursor;
